import React from 'react'
import { useHistory } from 'react-router'
import AuthModuleLayout from '../components/AuthModuleLayout'
import CreateNewPasswordForm from '../components/Forms/Authentication/CreateNewPasswordForm'
import LoginForm from '../components/Forms/Authentication/LoginForm'

export default function CreateNewPassword({ handleClose }) {
  const history = useHistory()

  return (
    <AuthModuleLayout heading="Change password Before Continue" login>
      <CreateNewPasswordForm handleClose={handleClose} />
    </AuthModuleLayout>
  )
}
